import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { formValueSelector } from "redux-form";
import renderDaterange from "../../../Components/Forms/daterange";
import { renderselapi, renderselect } from "../../../Components/Forms/renders";
import moment from "moment";

// Het formulier zelf
const FilterReservering = ({ vertrek, gastenprofielValue, meterstandvertrek, gastenprofiel, changeform, exporttoexcel }) => {
  useEffect(() => {
    changeform({ vertrek, gastenprofielValue, meterstandvertrek });
  }, [vertrek, gastenprofielValue, meterstandvertrek]);

  return (
    <form>
      <div className="row container filter py-2">
        <div className="col-md-3 col-sm-6 col-xs-12">
          <Field name="vertrek" type="number" mindate={true} maxdate={false} component={renderDaterange} label="Uitcheckdatum" />
        </div>
        <div className="col-md-3 col-sm-6 col-xs-12">
          <Field name="gastenprofiel" type="input" options={gastenprofiel} component={renderselapi} inputvalue="_id" inputnaam="naam" label="Kies een gastenprofiel" />
        </div>
        <div className="col-md-3 col-sm-6 col-xs-12">
          <Field name="meterstandvertrek" type="input" options={{ true: "Ja", false: "Nee" }} component={renderselect} label="Is de gast vertrokken?" />
        </div>
        <div className="col-md-3 col-sm-6 col-xs-12">
          <label className="control-label">Acties</label>
          <div>
            <button type="button" className="btn btn-primary btn-md" onClick={() => exporttoexcel()}>
              <i className="fa fa-file-excel-o"></i>&nbsp; Exporteren gegevens
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

// Verbind Redux-form
const reduxConnectedForm = reduxForm({
  form: "resreveringfilterform",
})(FilterReservering);

// Formulierwaarden ophalen via formValueSelector
const selector = formValueSelector("resreveringfilterform");

const mapStateToProps = (state, ownProps) => {
  const vertrek = selector(state, "vertrek");
  const gastenprofielValue = selector(state, "gastenprofiel");
  const meterstandvertrek = selector(state, "meterstandvertrek");

  return {
    vertrek,
    gastenprofielValue,
    meterstandvertrek,
    gastenprofiel: ownProps.gastenprofiel, // meegegeven van bovenaf
    initialValues: {
      datum: {
        uitcheckdatum: moment().subtract(7, "days"),
        enddate: new Date(),
      },
    },
  };
};

// Exporteer
export default connect(mapStateToProps)(reduxConnectedForm);
